function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M8.51 2v6.5H2v-.69C2 4.17 4.17 2 7.81 2h.7zM22 7.81v.69h-6.49V2h.68C19.83 2 22 4.17 22 7.81zm0 7.69v.69c0 3.64-2.17 5.81-5.81 5.81h-.68v-6.5H22zm-13.49 0V22h-.7C4.17 22 2 19.83 2 16.19v-.69h6.51z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M8.51 8.5H2v7h6.51v-7zM22 8.5h-6.49v7H22v-7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.51 8.5h-7v7h7v-7z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M15.51 2h-7v6.5h7V2zm0 13.5h-7V22h7v-6.5z"
})));